import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { IMAGES } from '../mock/mock';
import Reveal from '../components/Reveal';

const PageHero = ({ label, title, image }) => (
  <section className="relative h-[52vh] min-h-[420px] flex items-center justify-center overflow-hidden">
    <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0b2027]/80 via-[#0b2027]/55 to-[#0b2027]/85" />
    <div className="relative text-center px-6">
      <Reveal>
        <p className="text-[#c9a24b] uppercase tracking-[0.36em] text-xs mb-5">{label}</p>
        <h1 className="font-serif-display italic text-white text-5xl md:text-7xl">{title}</h1>
      </Reveal>
    </div>
  </section>
);

const MINISTRIES = [
  {
    id: 'kids', name: 'Hope Kids', ages: 'Ages 0–12', image: IMAGES.kids,
    text: 'A place where your children will learn about the love of God! Through a fun and safe environment your kids will participate in songs, storytelling, games, and crafts to learn God’s Word. It is never too early for children to know they were created for a plan and a purpose.',
  },
  {
    id: 'students', name: 'Students', ages: 'Middle & High School', image: IMAGES.students,
    text: 'We strive to lead students to become passionate followers of Christ. By partnering with parents and trained leaders, we teach and inspire the next generation to be founded in their faith and confident in their Creator through Bible study and small group gatherings.',
  },
  {
    id: 'men', name: 'Men', ages: 'All Ages', image: IMAGES.menFellowship,
    text: 'Husbands, fathers, brothers, sons — whatever your station, the important thing is that you’re not walking life alone. We meet, we lunch, we coffee, we walk, talk, and live life together as men, to become the men God designed us to be.',
  },
  {
    id: 'women', name: 'Women', ages: 'All Ages', image: IMAGES.womenStudy,
    text: 'There are several ways for women to grow in relationship with Jesus and with others — small groups, coffee meetings, fellowships, or gathering around God’s Word. We want every woman to know her worth and value in Christ, in every stage of life.',
  },
];

const Connect = () => {
  return (
    <div>
      <PageHero label="Do Life Together" title="Connect" image={IMAGES.groupIndoor} />

      <section className="bg-[#f6f2ea] py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
          <Reveal>
            <p className="text-[#3a4d54] text-xl md:text-2xl leading-relaxed font-serif-display italic">
              God has given us a family of believers to lean on and pray with as we navigate this life together. Here’s where you can find your place.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#f6f2ea] pb-28">
        <div className="max-w-7xl mx-auto px-5 md:px-8 space-y-24">
          {MINISTRIES.map((m, i) => (
            <Reveal key={m.id} className={`grid lg:grid-cols-2 gap-12 items-center`}>
              <div className={i % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="relative overflow-hidden group">
                  <img src={m.image} alt={m.name} className="w-full h-[440px] object-cover group-hover:scale-105 transition-transform duration-1000" />
                  <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
                </div>
              </div>
              <div className={i % 2 === 1 ? 'lg:order-1' : ''}>
                <p className="text-[#c9a24b] uppercase tracking-[0.3em] text-xs mb-4">{m.ages}</p>
                <h2 className="font-serif-display text-[#0f2e38] text-4xl md:text-5xl mb-6">{m.name}</h2>
                <p className="text-[#3a4d54] text-lg leading-relaxed">{m.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0f2e38] py-24 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <h2 className="font-serif-display italic text-white text-4xl md:text-5xl mb-6">Ready to get connected?</h2>
            <p className="text-white/70 text-lg mb-10">We’d love to help you find a small group or serving opportunity that fits your life.</p>
            <Link to="/plan-your-visit" className="btn-shine inline-flex items-center gap-3 border border-[#c9a24b] text-[#c9a24b] hover:bg-[#c9a24b] hover:text-[#0b2027] px-10 py-4 uppercase tracking-[0.22em] text-sm font-600 transition-all duration-300">
              Plan Your Visit <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Connect;
